<template>
    <div>

        <div class="row">
            <div class="col-8">
                <div class="highlight--stats">
                    <span class="stats--title mb-2">
                        {{ title }}
                        <i
                            class="fas fa-info-circle"
                            :id="title + 'info'"
                        ></i>
                        <b-popover :target="title + 'info'" triggers="hover" placement="top">
                          <template #title>{{ title }}</template>
                          {{ description }}
                        </b-popover>
                    </span>
                    <div class="value--unit">
                        <span class="stats--value">{{ value }}</span>
                        <span class="stats--unit col-md-0 col-sm-0 col-xs-0" v-if="!mobile">{{ unit }}</span>
                    </div>
                </div>
            </div>
            <div class="col-4 stats--icon">
                <i class="fas fa-4x" :class="icon"></i>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data () {
            return {
                mobile: this.isMobile(),
            }
        },
        props : [
            'title',
            'description',
            'value',
            'unit',
            'icon',
        ],
        mounted () {

        },
        methods : {

        }
    }
</script>

<style scoped>
    .highlight--stats {
        background-color: white;
        border-radius: 8px;
        /* box-shadow: 0px 3px 10px #0000000F; */
        padding: 30px 20px;

        display: flex;
        flex-direction: column;
        /* align-items: center; */
        justify-content: center;
    }

    .value--unit {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-end;
    }
    
    .stats--title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .stats--value {
        font-size: 40px;
        font-weight: bold;
        color: #545454;
    }

    .stats--unit {
        font-size: 14px;
        font-weight: 500;
        color: #D1D1D1;
        padding: 0 0 10px 10px;
    }

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }
</style>